export const products = [
    {
        productId: 1,
        title: 'Samsung Galaxy A21s 64 GB (Samsung Türkiye Garantili)',
        brand: 'Samsung',
        price: 2699.90,
        oldPrice: 2699.90,
        discount: 0,
        color: 'Beyaz',
        createdDate: '2021-01-12T15:17:46+03:00'
    },
    {
        productId: 2,
        title: 'Xiaomi Redmi Note 10 Pro 128 GB (Xiaomi Türkiye Garantili)',
        brand: 'Xiaomi',
        price: 3908.44,
        oldPrice: 4050.62,
        discount: 4,
        color: 'Mavi',
        createdDate: '2021-05-13T23:45:37+03:00'
    },
    {
        productId: 3,
        title: 'Samsung Galaxy A02s 32 GB (Samsung Türkiye Garantili)',
        brand: 'Samsung',
        price: 2049.90,
        oldPrice: 2299.00,
        discount: 11,
        color: 'Siyah',
        createdDate: '2021-01-03T03:33:57+03:00'
    },
    {
        productId: 4,
        title: 'Samsung Galaxy M12 64 GB (Samsung Türkiye Garantili)',
        brand: 'Samsung',
        price: 2399.00,
        oldPrice: 2499.00,
        discount: 4,
        color: 'Mavi',
        createdDate: '2021-01-08T15:22:02+03:00'
    },
    {
        productId: 5,
        title: 'Xiaomi Mi 11 Lite 128 GB (Xiaomi Türkiye Garantili)',
        brand: 'Xiaomi',
        price: 4368.00,
        oldPrice: 4550.00,
        discount: 4,
        color: 'Kirmizi',
        createdDate: '2021-01-15T02:38:35+03:00'
    },
    {
        productId: 6,
        title: 'Xiaomi Redmi 9T 128 GB (Xiaomi Türkiye Garantili)',
        brand: 'Xiaomi',
        price: 2819.00,
        oldPrice: 2999.00,
        discount: 6,
        color: 'Turuncu',
        createdDate: '2021-01-17T07:35:03+03:00'
    },
    {
        productId: 7,
        title: 'Xiaomi Redmi 9T 64 GB (Xiaomi Türkiye Garantili)',
        brand: 'Xiaomi',
        price: 2698.00,
        oldPrice: 2799.00,
        discount: 4,
        color: 'Siyah',
        createdDate: '2021-01-26T11:07:58+03:00'
    },
    {
        productId: 8,
        title: 'Samsung Galaxy A51 256 GB (Samsung Türkiye Garantili)',
        brand: 'Samsung',
        price: 3449.00,
        oldPrice: 3599.00,
        discount: 4,
        color: 'Mavi',
        createdDate: '2021-02-02T12:52:50+03:00'
    },
    {
        productId: 9,
        title: 'Oppo A54 128 GB (Oppo Türkiye Garantili)',
        brand: 'Oppo',
        price: 2645.00,
        oldPrice: 2699.00,
        discount: 2,
        color: 'Lacivert',
        createdDate: '2021-02-08T23:20:23+03:00'
    },
    {
        productId: 10,
        title: 'Xiaomi Redmi Note 10S 128 GB 6 GB Ram (Xiaomi Türkiye Garantili)',
        brand: 'Xiaomi',
        price: 3749.90,
        oldPrice: 3749.90,
        discount: 0,
        color: 'Siyah',
        createdDate: '2021-02-21T21:47:31+03:00'
    },
    {
        productId: 11,
        title: 'Oppo A73 128 GB (Oppo Türkiye Garantili)',
        brand: 'Oppo',
        price: 2800.00,
        oldPrice: 2999.00,
        discount: 7,
        color: 'Kirmizi',
        createdDate: '2021-02-27T05:14:21+03:00'
    },
    {
        productId: 12,
        title: 'Xiaomi Redmi Note 10 Pro 128 GB 8 GB RAM (Xiaomi Türkiye Garantili)',
        brand: 'Xiaomi',
        price: 4099.00,
        oldPrice: 4198.99,
        discount: 2,
        color: 'Gri',
        createdDate: '2021-02-28T01:50:52+03:00'
    },
    {
        productId: 13,
        title: 'Xiaomi Mi 11 256 GB (Xiaomi Türkiye Garantili)',
        brand: 'Xiaomi',
        price: 10996.00,
        oldPrice: 10996.00,
        discount: 4,
        color: 'Gri',
        createdDate: '2021-03-05T07:24:53+03:00'
    },
    {
        productId: 14,
        title: 'Poco X3 Pro 8 GB Ram 256 GB (Poco Türkiye Garantili)',
        brand: 'Poco',
        price: 3846.55,
        oldPrice: 4049.00,
        discount: 5,
        color: 'Beyaz',
        createdDate: '2021-03-20T10:33:32+03:00'
    },
    {
        productId: 15,
        title: 'iPhone SE 64 GB',
        brand: 'Apple',
        price: 4999.90,
        oldPrice: 5299.00,
        discount: 6,
        color: 'Siyah',
        createdDate: '2021-03-31T17:17:18+03:00'
    },
    {
        productId: 16,
        title: 'iPhone 12 Mini 64 GB',
        brand: 'Apple',
        price: 8199.90,
        oldPrice: 9999.00,
        discount: 18,
        color: 'Lacivert',
        createdDate: '2021-05-29T07:23:59+03:00'
    },
    {
        productId: 17,
        title: 'iPhone 12 Pro Max 128 GB',
        brand: 'Apple',
        price: 16670.00,
        oldPrice: 16999.00,
        discount: 2,
        color: 'Gri',
        createdDate: '2021-05-31T13:32:15+03:00'
    },
    {
        productId: 18,
        title: 'iPhone 12 Pro 256 GB',
        brand: 'Apple',
        price: 15149.89,
        oldPrice: 15999.00,
        discount: 5,
        color: 'Gri',
        createdDate: '2021-06-04T07:45:39+03:00'
    },
    {
        productId: 19,
        title: 'iPhone 12 Mini 128 GB',
        brand: 'Apple',
        price: 9699.00,
        oldPrice: 10499.00,
        discount: 8,
        color: 'Mavi',
        createdDate: '2021-06-14T11:53:02+03:00'
    },
    {
        productId: 20,
        title: 'iPhone SE 128 GB',
        brand: 'Apple',
        price: 5399.89,
        oldPrice: 5399.89,
        discount: 0,
        color: 'Siyah',
        createdDate: '2021-07-10T19:10:44+03:00'
    },
    {
        productId: 21,
        title: 'Poco X3 Pro 128 GB (Poco Türkiye Garantili)',
        brand: 'Poco',
        price: 3679.90,
        oldPrice: 3799.00,
        discount: 3,
        color: 'Beyaz',
        createdDate: '2021-07-18T18:26:14+03:00'
    },
    {
        productId: 22,
        title: 'Oppo Reno 5 Lite 128 GB (Oppo Türkiye Garantili)',
        brand: 'Oppo',
        price: 3459.90,
        oldPrice: 3799.00,
        discount: 9,
        color: 'Siyah',
        createdDate: '2021-07-26T13:43:26+03:00'
    },
    {
        productId: 23,
        title: 'Oneplus Nord N10 5G 128 GB (Oneplus Türkiye Garantili)',
        brand: 'Oneplus',
        price: 4199.90,
        oldPrice: 4299.00,
        discount: 2,
        color: 'Lacivert',
        createdDate: '2021-08-07T01:47:36+03:00'
    },
    {
        productId: 24,
        title: 'Oneplus 9 5G 128 GB (Oneplus Türkiye Garantili)',
        brand: 'Oneplus',
        price: 11499.01,
        oldPrice: 11499.01,
        discount: 0,
        color: 'Siyah',
        createdDate: '2021-08-10T16:23:52+03:00'
    },
    {
        productId: 25,
        title: 'Oneplus 9 Pro 5G 256 GB (Oneplus Türkiye Garantili)',
        brand: 'Oneplus',
        price: 14499.00,
        oldPrice: 14499.00,
        discount: 0,
        color: 'Gri',
        createdDate: '2021-08-18T17:44:38+03:00'
    },
    {
        productId: 26,
        title: 'Samsung Galaxy A02 32 GB (Samsung Türkiye Garantili)',
        brand: 'Samsung',
        price: 1870.11,
        oldPrice: 1889.00,
        discount: 1,
        color: 'Kirmizi',
        createdDate: '2021-08-19T05:06:35+03:00'
    },
    {
        productId: 27,
        title: 'Xiaomi Redmi Note 8 64 GB (Xiaomi Türkiye Garantili)',
        brand: 'Xiaomi',
        price: 2699.00,
        oldPrice: 2799.00,
        discount: 4,
        color: 'Mavi',
        createdDate: '2021-08-22T21:36:37+03:00'
    },
    {
        productId: 28,
        title: 'Oppo Realme C21 32 GB (Realme Türkiye Garantili)',
        brand: 'Oppo',
        price: 1649.00,
        oldPrice: 1799.00,
        discount: 8,
        color: 'Siyah',
        createdDate: '2021-01-03T06:52:18+03:00'
    },
    {
        productId: 29,
        title: 'Huawei P40 Lite 128 GB (Huawei Türkiye Garantili)',
        brand: 'Huawei',
        price: 3289.00,
        oldPrice: 3799.00,
        discount: 13,
        color: 'Siyah',
        createdDate: '2021-01-24T19:48:06+03:00'
    },
    {
        productId: 30,
        title: 'Huawei P Smart S 128 GB (Huawei Türkiye Garantili)',
        brand: 'Huawei',
        price: 2765.00,
        oldPrice: 2999.00,
        discount: 8,
        color: 'Siyah',
        createdDate: '2021-04-23T09:49:04+03:00'
    },
    {
        productId: 31,
        title: 'Huawei Y5p 32 GB (Huawei Türkiye Garantili)',
        brand: 'Huawei',
        price: 1565.00,
        oldPrice: 2399.00,
        discount: 35,
        color: 'Mavi',
        createdDate: '2021-05-16T16:18:12+03:00'
    },
    {
        productId: 32,
        title: 'Huawei P30 Lite 128 GB (Huawei Türkiye Garantili)',
        brand: 'Huawei',
        price: 3390.00,
        oldPrice: 3499.00,
        discount: 3,
        color: 'Mavi',
        createdDate: '2021-07-06T15:38:43+03:00'
    },
    {
        productId: 33,
        title: 'Huawei Y6 2019 32 GB (Huawei Türkiye Garantili)',
        brand: 'Huawei',
        price: 1899.00,
        oldPrice: 2299.00,
        discount: 17,
        color: 'Turuncu',
        createdDate: '2021-07-11T03:36:19+03:00'
    },
    {
        productId: 34,
        title: 'Huawei P30 Lite 64 GB (Huawei Türkiye Garantili)',
        brand: 'Huawei',
        price: 2999.00,
        oldPrice: 3199.00,
        discount: 6,
        color: 'Beyaz',
        createdDate: '2021-08-05T05:49:22+03:00'
    },
    {
        productId: 35,
        title: 'Huawei Y6p 64 GB (Huawei Türkiye Garantili)',
        brand: 'Huawei',
        price: 2145.00,
        oldPrice: 2699.00,
        discount: 21,
        color: 'Yesil',
        createdDate: '2021-08-22T21:47:58+03:00'
    },
    {
        productId: 36,
        title: 'Huawei P40 128 GB (Huawei Türkiye Garantili)',
        brand: 'Huawei',
        price: 7988.00,
        oldPrice: 8499.00,
        discount: 6,
        color: 'Siyah',
        createdDate: '2021-01-12T17:30:54+03:00'
    }
];